import React, { useState } from "react";
import { useLanguage } from "../ui/LanguageProvider";

// 권한 없는 메뉴/URL 진입 시 본문에 뜨는 안내 + 권한 요청 버튼.
// CRM·IT-CONSULTING 두 레이아웃이 같은 화면을 쓰므로 여기 한 곳에만 둔다.
// 요청은 super_admin 에게 알림(벨) + Slack 으로 전달되고, 관리자는 /settings/menus 에서 등급을 바꾼다.
export default function AccessDeniedNotice({
  menuKey,
  menuLabel,
}: {
  menuKey: string | null;
  menuLabel?: string;
}) {
  const { t } = useLanguage();
  const [state, setState] = useState<"idle" | "sending" | "done" | "error">("idle");
  const [message, setMessage] = useState("");

  const request = async () => {
    setState("sending");
    try {
      const res = await fetch("/api/auth-users/access-request", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ menuKey, menuLabel, path: window.location.pathname }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || t(`요청에 실패했습니다. (${res.status})`, `Request failed. (${res.status})`));
      setState("done");
      setMessage(data.deduped ? t("이미 접수된 요청이 있습니다. 관리자 확인을 기다려 주세요.", "A request is already pending. Please wait for an admin to review it.") : t("관리자에게 요청을 보냈습니다.", "Request sent to an admin."));
    } catch (e) {
      setState("error");
      setMessage(e instanceof Error ? e.message : t("요청에 실패했습니다.", "Request failed."));
    }
  };

  return (
    <div style={{ padding: "48px 24px", textAlign: "center", color: "var(--crm-text-secondary, #64748b)" }}>
      <div style={{ fontSize: 15, fontWeight: 700, color: "var(--crm-text-primary, #1f2937)", marginBottom: 6 }}>{t("접근 권한이 없습니다", "Access denied")}</div>
      <div style={{ fontSize: 13 }}>{t("이 메뉴는 현재 계정 권한으로 접근할 수 없습니다. 관리자에게 문의하세요.", "Your account doesn't have access to this menu. Please contact an admin.")}</div>
      {menuKey ? (
        <div style={{ marginTop: 16 }}>
          <button
            type="button"
            onClick={request}
            disabled={state === "sending" || state === "done"}
            style={{
              padding: "8px 16px",
              fontSize: 13,
              fontWeight: 600,
              borderRadius: 8,
              border: "1px solid #d0d5dd",
              background: state === "done" ? "#f2f4f7" : "#fff",
              color: state === "done" ? "#5b6472" : "#1f2937",
              cursor: state === "sending" || state === "done" ? "default" : "pointer",
            }}
          >
            {state === "sending" ? t("요청 중…", "Requesting…") : state === "done" ? t("요청 완료", "Requested") : t("권한 요청", "Request access")}
          </button>
          {message ? (
            <div style={{ marginTop: 8, fontSize: 12, color: state === "error" ? "#d92d20" : "#039855" }}>{message}</div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
